import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
export type UpdateProductAttributeMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.UpdateCoreProductAttributeInput;
}>;

export type UpdateProductAttributeMutationResult = { __typename?: 'Mutation' } & {
  updateCoreProductAttribute: { __typename?: 'UpdateCoreProductAttributePayload' } & {
    coreProductAttribute?: GraphQLTypes.Maybe<
      { __typename?: 'CoreProductAttribute' } & Pick<GraphQLTypes.CoreProductAttribute, 'id' | 'name' | 'type'>
    >;
    errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
  };
};

export const UpdateProductAttributeDocument = gql`
  mutation updateProductAttribute($input: UpdateCoreProductAttributeInput!) {
    updateCoreProductAttribute(input: $input) {
      coreProductAttribute {
        id
        name
        type
      }
      errors {
        message
        path
      }
    }
  }
`;
